<template>
	<section class="content-wrapper">
		<router-link to="/" exact class="btn btn-back">
			<img
				src="images/chevron-left-green.svg"
				style="margin-right: 6px"
			/>powrót
		</router-link>

		<h1>moje dane</h1>

		<preview-company v-if="userData.isCompany" />
		<preview-indyvidual v-else />

		<router-link
			to="/"
			v-if="windowWidth < mobileBreakpoint"
			exact
			class="btn btn-secondary"
			>Powrót</router-link
		>
	</section>
</template>

<script>
import PreviewCompany from '@/views/myFx/MyFxPreviewCompany';
import PreviewIndyvidual from '@/views/myFx/MyFxPreviewIndyvidual';
import { getMyFx } from '@/mixins/get-my-fx';
import { mapGetters } from 'vuex';

export default {
	data() {
		return {
			loader: true,
		};
	},
	mixins: [getMyFx],
	components: {
		PreviewCompany,
		PreviewIndyvidual,
	},
	computed: {
		windowWidth() {
			return this.$store.getters.getWindowWidth;
		},
		userData() {
			return this.$store.getters.getUser
				? this.$store.getters.getUser
				: false;
		},
		...mapGetters({ mobileBreakpoint: 'getMobileBreakpoing' }),
	},
	beforeMount() {
		this.$store.dispatch('fetchMyFx');
		this.$store.dispatch(
			'fetchLogOutTimer',
			this.$store.getters.getTimeToLogout
		);
	},
};
</script>
